import SpriteSymbol from "../../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "entertainment",
  "use": "entertainment-usage",
  "viewBox": "0 0 32 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 26\" id=\"entertainment\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M24.5 24h-17a1 1 0 000 2h17a1 1 0 000-2\" data-name=\"Fill-4\" /><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M2 3a1 1 0 011-1h26a1 1 0 011 1v17H2zm28-3H2a2 2 0 00-2 2v19a2 2 0 002 2h28a2 2 0 002-2V2a2 2 0 00-2-2z\" data-name=\"Fill-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol